import { Dialog, DialogContent, useMediaQuery, useTheme } from "@mui/material";
import { OutreachTemplatesContext } from "contexts/OutreachTemplates";
import { SlideAnimationProvider } from "contexts/SlideAnimation";
import { useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { routes } from "schemas/routes";

import { isPage } from "utils/general";
import { trackEvent } from "utils/tracking";

import ConversationalTemplate from "./BentoAIFlow";

export default function CreateTemplate() {
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down("md"));
  const { createTemplateDialogOpen, setCreateTemplateDialogOpen } = useContext(
    OutreachTemplatesContext,
  );
  const navigate = useNavigate();

  const handleClose = () => {
    setCreateTemplateDialogOpen(false);
    if (isPage(routes.templates)) {
      navigate(`/${routes.templates}`);
    }
  };

  useEffect(() => {
    trackEvent("Template Generation Drawer Shown");
  }, []);

  return (
    <Dialog
      open={createTemplateDialogOpen}
      onClose={handleClose}
      fullScreen={isMobileScreen}
      maxWidth="md"
    >
      <DialogContent
        sx={isMobileScreen ? { alignItems: "center", display: "flex" } : {}}
      >
        <SlideAnimationProvider>
          <ConversationalTemplate />
        </SlideAnimationProvider>
      </DialogContent>
    </Dialog>
  );
}
